import styled from "styled-components";

export const LiveStreamingTileDefaultBox = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;

    &::after {
        content: "";
        display: block;
        width: 100%;
        height: 10px;
        background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.25) 20%, rgba(0, 0, 0, 0));
    }

    @media ${({theme}) => `${theme.mediaQuery.lAndBelow} and ${theme.mediaQuery.landscape}`} {
        padding: 0 12.5vw;
    }

    @media ${({theme}) => `${theme.mediaQuery.mAndBelow} and ${theme.mediaQuery.landscape}`} {
        padding: 0 25vw;
    }
`;